import React, { createContext, useState, useContext } from 'react';
import Axios from 'axios';
import mixpanel from 'mixpanel-browser';
import * as Config from '../../Config';
import { NotifContext } from './NotifContext';
import { ProfileContext } from './ProfileContext';

export const PaymentContext = createContext();

const PaymentContextProvider = (props) => {
  const [items, setItems] = useState([]);
  const { show } = useContext(NotifContext);
  const [shouldLoad, setShouldLoad] = useState(false);

  const loggedin = localStorage.getItem('loggedin') === 'true';
  const config = { withCredentials: true };

  const getModels = () => {
    const api = `${Config.inventoryAPI}`;
    Axios.get(api, config)
      .then((res) => {
        const response = res.data;
        if (response.error || response.code === 1) {
          mixpanel.track('Payment Flow Error: Fetch Items', {
            api,
            response,
            has_token: Boolean(config.headers?.Authorization),
          });
          // error message
        } else {
          setItems(response.payload.items);
        }
      })
      .catch((e) => {
        mixpanel.track('Payment Flow Error: Fetch Items', {
          api,
          has_token: Boolean(config.headers?.Authorization),
        });
        console.log('e', e);
      });
  };

  const initiatePayment = (item) => {
    const api = `${Config.paymentAPI}/paypal/pay?item=${item}`;
    if (loggedin) {
      setShouldLoad(true);
      Axios.get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track('Error with Payment initiation process', {
              api,
              response,
              has_token: Boolean(config.headers?.Authorization),
            });
            // error message
            setShouldLoad(false);
            show(
              'info',
              'Ah an error occured!',
              `We are unable to process your request, please try after sometime`,
              'topRight'
            );
          } else {
            setShouldLoad(false);
            if (response.redirect) {
              window.location.href = response.redirect_url;
            }
          }
        })
        .catch((e) => {
          mixpanel.track('Error with Payment initiation process', {
            api,
            has_token: Boolean(config.headers?.Authorization),
          });
          console.log('e', e);
        });
    } else {
      show(
        'info',
        'Ah an error occured!',
        `You must login to buy premium, please login!`,
        'topRight'
      );
    }
  };

  return (
    <PaymentContext.Provider
      value={{
        items,
        setItems,
        getModels,
        initiatePayment,
        shouldLoad,
      }}
    >
      {props.children}
    </PaymentContext.Provider>
  );
};

export default PaymentContextProvider;
